import "./style/recipe.scss"

import React from "react"

// Components
import { Image } from "@ng-mw/shared-react-components/shared"
import { FavoriteRecipeButton } from "@ng-mw/shared-react-components/recipes"
import { getViewportScaledImageConf } from "@data/MenyImageConfig"
import { RecipeItem } from "@app/types"
import { SharedRecipe } from "./shared-recipes/loaders"

export interface RecipeProps {
    recipeItem?: RecipeItem
    recipeId?: string
}

const Recipe = ({ recipeItem, recipeId }: RecipeProps) => {
    return (
        <div className="recipe">
            <div className="recipe__image">
                <Image
                    filename={recipeItem?.rawData?.media?.imageId}
                    config={getViewportScaledImageConf({
                        maxWidth: 800,
                        aspect: 2,
                        ratio: 0.8,
                    })}
                    objectFit="cover"
                />
                {recipeItem ? (
                    <FavoriteRecipeButton
                        recipeId={recipeItem.rawData.id}
                        recipeName={recipeItem.rawData.name}
                        loadFavoritesOnCreate
                    />
                ) : null}
            </div>
            <SharedRecipe
                recipeId={recipeId ?? ""}
                showTip
            />
        </div>
    )
}

export default Recipe
